import React, { Component } from 'react';
import axios from 'axios';
import _ from 'lodash';
import { API_URL } from '../../partials/Globals';
import Errors from '../../partials/Errors';
import Message from '../../partials/Message';
import GroupAdmin from './GroupAdmin';

export default class HandleAdmins extends Component {
    state = {
        errors: '',
        message: '',
        admins: '',
        group: {
            id: '',
            name: ''
        }
    }

    constructor(props) {
        super(props);

        this.fetchAdmins = this.fetchAdmins.bind(this);
        this.fetchGroup = this.fetchGroup.bind(this);
    }

    componentDidMount() {
        this.fetchAdmins();
        this.fetchGroup();
    }

    fetchAdmins() {
        var self = this;

        // Hämta alla administratörer
        axios.get(API_URL+'/admin/groups/admins')
            .then(response => {
                var admins = _.filter(response.data, ['is_super_admin', 0]);
                self.setState({ admins: admins });
            });
    }

    fetchGroup() {
        var self = this;

        // Hämta gruppen
        axios.get(API_URL+'/admin/groups/'+this.props.match.params.id)
            .then(response => {
                self.setState({ group: response.data });
            });
    }

    render() {
        const self = this;

        return (
            <div>
                <div className="top">
                    <div className="col-12">
                        <button className="back" onClick={ this.props.history.goBack }>Tillbaka</button>
                    </div>
                </div>

                <Message message={ this.state.message } />
                <Errors errors={ this.state.errors } />

                <div className="container">
                    <div className="content">
                        <h1>Hantera administratörer för { this.state.group.name }</h1>

                        <div className="block">
                            <div className="header">
                                <h4>Administratörer</h4>
                            </div>
                            <div className="body">
                                { (this.state.admins.length > 0 && this.state.group.id) &&
                                    <ul className="has-icons">
                                        { Object.keys(this.state.admins).map(function(key) {
                                            return <GroupAdmin key={ key } user={ self.state.admins[key] } group_id={ self.state.group.id } update={ self.fetchAdmins } />
                                        }) } 
                                    </ul>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/superadmin/Group/HandleAdmins.js